import { type Priority, Priorities, type ProjectStatus, ProjectStatuses } from '@pmai/contracts';
import { StatusBadge } from '@pmai/ui';
import { useEnumLabel } from '../../shared/i18n';

export function ProjectStatusBadge({ status }: { status: ProjectStatus }) {
  const label = useEnumLabel();
  const option = ProjectStatuses.byCode(status);
  return <StatusBadge tone={option.tone} label={label(option)} />;
}

export function PriorityBadge({ priority }: { priority: Priority }) {
  const label = useEnumLabel();
  const option = Priorities.byCode(priority);
  return <StatusBadge tone={option.tone} label={label(option)} />;
}
